export default __webpack_public_path__ + "b4a99381b5ee317d9fca7fb28c41c36a.svg";